import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';

@Pipe({
  name: 'shortNumber',
  pure: false
})
export class ShortNumberPipe implements PipeTransform {

  constructor(private sharedService: SharedService) {} 

  transform(value: number, tofix?: number): any {
    const programInfo = this.sharedService.programInfo; 

    if (value) {
      const abs = Math.abs(value);

      if (abs >= Math.pow(10, 12) && programInfo !== undefined) {
        return (value / Math.pow(10, 12)).toFixed(tofix ?? programInfo.point_decimal_scale) + 'T';
      } else if (abs >= Math.pow(10, 9) && programInfo !== undefined) {
        return (value / Math.pow(10, 9)).toFixed(tofix ?? programInfo.point_decimal_scale) + 'B';
      } else if (abs >= Math.pow(10, 6) && programInfo !== undefined) {
        return (value / Math.pow(10, 6)).toFixed(tofix ?? programInfo.point_decimal_scale) + 'M';
      } else if (abs >= Math.pow(10, 3) && programInfo !== undefined) {
        return (value / Math.pow(10, 3)).toFixed(tofix ?? programInfo.point_decimal_scale) + 'K';
      }
    }

    return value;
  }
}